import service from '@/assets/js/request'

// 企点-查询客户
export const getQidianClientUser = (host, data = {}) => {
  return service({
    url: `${host}/api/v3/qidian/client/user`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/qidian.js